import React, { useEffect, useState } from "react";
import { Row, Col, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown, Modal } from "reactstrap";
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory, { PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone } from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { CSVExport } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit';
import userServices from "../services/user.services";
import { useFormik } from "formik";
import { UserSchema } from "../schema/UserSchema";
import { toast } from 'react-toastify';
import stateServices from "../services/state.services";
import cityServices from "../services/city.services";
import UserForm from "./User/UserForm";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import ExportExcel from "./ExportExcel";
import webPortalServices from "../services/webPortal.services";
import TableNoDataIndication from "./common/TableNoDataIndication";
const UserInfo = () => {
    const { ExportCSVButton } = CSVExport;
    const [modal, setModal] = React.useState(false);
    const toggle = () => setModal(!modal);
    const [users, setUsers] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [selectedRow, setSelectedRow] = useState();
    const [isAddMode, setIsAddMode] = useState('Add');
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true);
    const getAllUsers = () => {
        const result = userServices.getAllUsersLocation()
            .then((res) => {
                if (res.data.status === "success") {
                    console.log('rs', res.data.user_locations)


                    setUsers(res.data.user_locations)
                }
                setLoading(false);
            }).catch((error) => {
                console.log('error', error)
                setLoading(false);
            })
    }

    const formik = useFormik({
        initialValues: {
            email: '',
            password: '',
            fullName: '',
            mobile: '',
            location: '',
            city: '',
            state: '',
        },
        validationSchema: UserSchema('user'),
        onSubmit: async (values, actions) => {
            const reqBody = {
                name: values.fullName,
                gender: "male",
                mobile: values.mobile,
                email: values.email,
                user_type_id: 1,
                password: values.password,
                location: values.location,
                state: values.state,
                city: values.city,
                latitude: "45.1254",
                longitude: "46.2548"
            }

            const result = await userServices.createUser(reqBody);
            if (result.data.status === true) {
                actions.resetForm();
                getAllUsers()
                toggle()
                toast.success('User registration successfully', { toastId: 'registration_success', autoClose: 3000 });
            } else {
                toast.error(result.data.message, { toastId: 'registration_fail', autoClose: 3000 });
            }
        },
        enableReinitialze: true,
    });

    const tblColumn = [{
        dataField: 'location_type',
        text: 'Location Type',
        sort: true
    }, {
        dataField: 'appartment_road_area',
        text: 'Appartment Road Area',
        sort: false
    }, {
        dataField: 'full_location',
        text: 'Full Location',
        sort: false
    }];


    const defaultSorted = [{
        dataField: '_id',
        order: "desc",
    }];
    const pzipcodeOptions = {
        sizePerPzipcode: 10,
        totalSize: users.length, // replace later with size(customers),
        custom: true
    };

    const deleteUserById = async (id) => {
        const result = await userServices.deleteUserById({ id: id });
        if (result.data.status === true) {
            toast.success(result.data.message, { toastId: 'userDelete_success', autoClose: 3000 });
            getAllUsers();
        } else {
            toast.error(result.data.message, { toastId: 'userDelete_faild', autoClose: 3000 });
        }
    }

    const handleChangeStatus = async (id, status) => {
        console.log('status', status);
        const result = await userServices.updateUserById(id, { status: status })
        if (result.data.status === true) {
            getAllUsers()
            toast.success('Status updated successfully', { toastId: 'update_success', autoClose: 3000 });
        } else {
            toast.error(result.data.message, { toastId: 'update_fail', autoClose: 3000 });
        }
    }


    useEffect(() => {
        // getAllUsers();
        const getAllStates = stateServices.getAllStates().then((res) => {
            if (res.data.status === true) {
                setStates(res.data.states)
            }
        });
        const getAllCity = cityServices.getAllCity().then((res) => {
            if (res.data.status === true) {
                setCities(res.data.cities)
            }
        });

        webPortalServices.getData().then((res) => {
            console.log('res', res.data.arr)
            setData(res.data.arr)
        });
    }, [])
    return (
        <React.Fragment>
            {/*page-wrapper*/}
            <div className="page-wrapper">
                {/*page-content-wrapper*/}
                <div className="page-content-wrapper">
                    <div className="page-content">
                        <>
                            {/*breadcrumb*/}
                            <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                                <div className="breadcrumb-title pe-3">Users</div>
                                <div className="ps-3">
                                    <nav aria-label="breadcrumb">
                                        <ol className="breadcrumb mb-0 p-0">
                                            <li className="breadcrumb-item">
                                                <a href="#">
                                                    {/* <i className="bx bx-home-alt" /> */}
                                                </a>
                                            </li>
                                            <li className="breadcrumb-item active" aria-current="page">
                                                user
                                            </li>
                                        </ol>
                                    </nav>
                                </div>
                                <div className="ms-auto">
                                    <div className="btn-group">
                                        {/* <button className="btn btn-primary"
                                            onClick={() => {
                                                toggle();
                                                setIsAddMode('Add')
                                            }}><i className="bx bx plus" />&nbsp;Add</button> */}
                                        <ExportExcel excelData={data} fileName={"Excel Export"} />
                                        <Modal isOpen={modal} toggle={toggle} size="lg">

                                            <UserForm toggle={toggle} isAddMode={isAddMode} cities={cities} states={states} getAllUsers={getAllUsers} selectedRow={selectedRow} />
                                        </Modal>
                                    </div>
                                </div>
                            </div>
                            {/*end breadcrumb*/}
                            <div className="card">
                                <div className="card-body">
                                    <div className="card-title">
                                        {/* <h4 className="mb-0">Users</h4> */}
                                    </div>
                                    <hr />

                                    <React.Fragment>
                                        <PaginationProvider
                                            pagination={paginationFactory(pzipcodeOptions)}
                                            keyField='id'
                                            columns={tblColumn}
                                            data={users}
                                        >
                                            {({ paginationProps, paginationTableProps }) => (
                                                <ToolkitProvider
                                                    keyField='_id'
                                                    columns={tblColumn}
                                                    data={users}
                                                    exportCSV
                                                >
                                                    {toolkitProps => (
                                                        <React.Fragment>
                                                            <Row className="mb-2" style={{ display: 'none' }}>
                                                                <Col md="4">
                                                                    <div className="search-box me-2 mb-2 d-inline-block">
                                                                        <div className="status-relative">
                                                                        </div>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col xl="12">
                                                                    <div className="table-responsive">
                                                                        <ExportCSVButton {...toolkitProps.csvProps}>Export CSV!!</ExportCSVButton>
                                                                        <hr />
                                                                        <BootstrapTable
                                                                            noDataIndication={<TableNoDataIndication loading={loading} />}
                                                                            keyField={"id"}
                                                                            responsive
                                                                            bordered={false}
                                                                            striped={false}
                                                                            defaultSorted={defaultSorted}
                                                                            classes={
                                                                                "table table-striped align-middle table-nowrap"
                                                                            }
                                                                            headerWrapperClasses={"thead-light"}
                                                                            {...toolkitProps.baseProps}
                                                                            {...paginationTableProps}
                                                                        />
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                            {users.length > 0 &&
                                                                <Row className="align-items-md-center mt-30">
                                                                    <Col className="inner-custom-pagination mt-2 d-flex">
                                                                        <div className="d-inline">
                                                                            <SizePerPageDropdownStandalone
                                                                                {...paginationProps}
                                                                            />
                                                                        </div>
                                                                        <div className="text-md-right ms-auto">
                                                                            <PaginationListStandalone
                                                                                {...paginationProps}
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            }
                                                        </React.Fragment>
                                                    )
                                                    }
                                                </ToolkitProvider>
                                            )
                                            }</PaginationProvider>
                                    </React.Fragment>
                                </div>
                            </div>

                        </>

                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default UserInfo;